import React from "react"
import { useTranslation } from "react-i18next"

export const TimelineSteps = ({ steps }) => {
    const { t } = useTranslation()

    return (
        <div className="c-timeline my-7">
            {Boolean(steps) && steps.map((step, index) => (
                <div className={`c-timeline__item ${step.isDisabled ? "is-disabled" : ""} ${step.isActive ? "is-active" : ""}`} key={index}>
                    <div className="c-timeline__index mb-2">{index + 1}</div>
                    <p>{step.label}</p>
                    {step.date && <p>{t("global.the")} {step.date}</p>}
                </div>
            ))}
        </div>
    )
}
